module.exports = __webpack_public_path__ + "static/img/i1.a3987a15.png";